import { Link } from "react-router-dom";

const formations = [
  {
    title: "CACES – Certificat d’Aptitude à la Conduite En Sécurité",
    description:
      "Préparez-vous à conduire en toute sécurité avec une certification reconnue dans les secteurs logistique, BTP et industriel.",
  },
  {
    title: "Intelligence Artificielle (IA)",
    description:
      "Plongez dans le monde de l’IA : apprentissage automatique, traitement des données et automatisation intelligente.",
  },
  {
    title: "Sauveteur Secouriste du Travail (SST)",
    description:
      "Apprenez les bons réflexes pour intervenir efficacement en situation d'urgence et garantir la sécurité en entreprise.",
  },
  {
    title: "Coiffure et Esthétique",
    description:
      "Formez-vous aux dernières techniques de beauté, soins capillaires et tendances esthétiques professionnelles.",
  },
  {
    title: "Vente et Marketing Digital",
    description:
      "Maîtrisez le SEO, les réseaux sociaux, la publicité en ligne et créez des campagnes digitales percutantes.",
  },
  {
    title: "Design Graphique",
    description:
      "Exprimez votre créativité avec des outils de design modernes pour réaliser des visuels uniques et professionnels.",
  },
  {
    title: "Soft Skills - Gestion du Stress - Initiation",
    description:
      "Améliorez votre efficacité personnelle en maîtrisant le stress, la communication et l’intelligence émotionnelle.",
  },
  {
    title: "Développement Web",
    description:
      "Apprenez à construire des sites web modernes, interactifs et responsives en utilisant les technologies les plus demandées.",
  },
  {
    title: "Langues Étrangères (Français, Anglais, etc.)",
    description:
      "Développez vos compétences linguistiques pour évoluer à l’international ou dans un cadre professionnel exigeant.",
  },
  {
    title: "Kinésithérapie",
    description:
      "Formations spécialisées pour intégrer ou perfectionner votre parcours dans les métiers paramédicaux et de santé.",
  },
  {
    title: "Outils Bureautiques (Excel, Word, PowerPoint)",
    description:
      "Devenez expert des outils bureautiques indispensables à la productivité au travail et à la gestion de projet.",
  },
  {
    title: "Comptabilité & Paie",
    description:
      "Maîtrisez les fondamentaux de la gestion comptable, de la paie et des obligations sociales en entreprise.",
  },
  {
    title: "Sécurité",
    description:
      "Développez les compétences nécessaires pour prévenir les risques et intervenir efficacement en cas d’incident.",
  },
  {
    title: "Reconversion Professionnelle – Coaching & Accompagnement",
    description:
      "Explorez de nouvelles voies avec un accompagnement personnalisé pour réussir votre transition de carrière.",
  },
  {
    title: "CAO - DAO",
    description:
      "Maîtrisez les logiciels de dessin technique pour concevoir des projets précis dans l’architecture ou l’industrie.",
  },
];

const FormationUnavailableFallback = () => {
  return (
    <main className="min-h-screen px-6 py-12 bg-gradient-to-b from-[#fffdf6] via-white to-[#fffdf6] flex flex-col items-center">
      <h1 className="text-4xl sm:text-5xl font-extrabold mb-6 text-center max-w-3xl">
        Bienvenue chez{" "}
        <span className="text-orange-600">Valacademy Formations</span>
      </h1>
      <p className="text-lg text-gray-700 max-w-2xl text-center mb-10 leading-relaxed">
        Nous n’avons pas trouvé la formation que vous recherchez, mais voici un
        aperçu de nos programmes les plus demandés. Valacademy Formations vous
        accompagne dans votre montée en compétences avec des formations
        modernes, utiles et orientées marché.
      </p>

      <section className="max-w-5xl w-full">
        <h2 className="text-2xl font-semibold text-[#a94400] mb-6 text-center">
          Nos Formations Recommandées
        </h2>
        <ul className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {formations.map(({ title, description }) => (
            <Link
              to={`/formation/${title}`}
              key={title}
              className="bg-white rounded-2xl shadow-lg p-6 border border-[#f1e8dd] hover:shadow-xl transition-shadow duration-300 hover:bg-orange-50 block"
            >
              <h3 className="text-lg font-bold text-orange-600">{title}</h3>
              <p className="mt-2 text-sm text-gray-600">{description}</p>
            </Link>
          ))}
        </ul>
      </section>
    </main>
  );
};

export default FormationUnavailableFallback;
